import React from 'react'
import useViewportSize from '../../components/useViewportSize'

import MapPlaceHolder from './MapPlaceHolder'
import NewMap from './Map'

function calculateHeight(viewport, mobile, view, showBottom, state) {
  let height
  let marginTop

  height = viewport.height
  marginTop = 0

  if (mobile) height = '100vh'

  return [height, marginTop]
}

export default function Page(props) {
  const viewport = useViewportSize()
  const [height, marginTop] = calculateHeight(
    viewport,
    props.mobile,
    props.view,
    props.showBottom,
    props.state
  )

  if (props.showMapPlaceholder) {
    return <MapPlaceHolder height={height} marginTop={marginTop} isMobile={props.mobile} />
  }

  return <NewMap height={height} marginTop={marginTop} {...props} />
}
